import {
  SEARCH_PARAMS_INIT,
  SEARCH_PARAMS_UPDATE,
  START_FLIGHT_SEARCH,
  SEARCH_RESULTS_INIT,
  FLIGHT_SEARCH_FAILED,
  SELECT_A_FLIGHT,
  CLEAR_SELECTED_FLIGHT,
  STORE_RESERVATION_DETAILS,
  UPDATE_TIMER,
  INIT_PASSENGER_DETAILS,
  UPDATE_PASSENGER_DETAIL,
  STORE_CONTACT_DETAILS,
  CHANGE_FLIGHT_SORTER,
  RESET_FLIGHTS_UI,
  SHOW_RESERVATION_FAILED_MESSAGE,
  STORE_FLIGHTS_PAYMENT_DETATILS,
  BOOK_SELECTED_FLIGHTS,
  // STORE_FLIGHTS_BOOKING_PROCESS_ID,
  // STORE_FLIGHT_BOOKING_ID,
} from '../actions/types';

const INITIAL_STATE = {
  searchParams: {
    from_location: 'KTM',
    to_location: 'LUA',
    departure_date: '',
    arrival_date: '',
    trip_type: 'R',
    num_adults: 1,
    num_children: 0,
    nationality: 'US',
    searching: false,
    trekId: null,
    trekStartDate: null,
  },
  searchResults: {
    inbound: [],
    outbound: [],
    sortBy: null,
  },
  selectedFlights: {
    inbound: {},
    outbound: {},
  },
  reservationDetails: {
    reservation_status: '',
  },
  countdowntimer: {
    remainingTime: null,
  },
  passengerDetails: {
    allIds: ['0'],
    byId: {
      '0': {
        first_name: '',
        last_name: '',
        middle_name: '',
        pax_type: 'Adult',
        title: 'Ms',
        nationality: '',
        remarks: '',
      },
    },
  },
  contactPerson: {
    first_name: '',
    last_name: '',
    contact_email: '',
    contact_mobile: '',
  },
  passengerDetailsValidation: {
    isActive: false,
    passengerErrors: {},
    contactsErrors: {},
  },
  paymentDetails: {},
};

export default (state = INITIAL_STATE, action) => {
  const {
    searchParams,
    parameter,
    value,
    searchResult,
    flightType,
    selectedFlight,
    reservationDetails,
    remainingTime,
    passengerDetails,
    contactPerson,
    passengerId,
    passengerDetail,
    sorter,
    paymentDetails,
    // process_id,
    // transaction_id,
    // flightBookingId,
  } = action;
  switch (action.type) {
    case SEARCH_PARAMS_INIT:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...searchParams,
          searching: false,
        },
        searchResults: {
          inbound: [],
          outbound: [],
          sortBy: null,
        },
        selectedFlights: {
          inbound: {},
          outbound: {},
        },
      };
    case SEARCH_PARAMS_UPDATE:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          [parameter]: value,
          searching: false,
        },
        searchResults: {
          inbound: [],
          outbound: [],
          sortBy: null,
        },
        selectedFlights: {
          inbound: {},
          outbound: {},
        },
      };
    case START_FLIGHT_SEARCH:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          searching: true,
        },
        searchResults: {
          inbound: [],
          outbound: [],
          sortBy: null,
        },
        selectedFlights: {
          inbound: {},
          outbound: {},
        },
      };
    case SEARCH_RESULTS_INIT:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          searching: false,
        },
        searchResults: {
          ...searchResult,
          sortBy: null,
        },
      };
    case FLIGHT_SEARCH_FAILED:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          searching: false,
        },
      };
    case CHANGE_FLIGHT_SORTER:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          sortBy: sorter,
        },
      };
    case SELECT_A_FLIGHT:
      return {
        ...state,
        selectedFlights: {
          ...state.selectedFlights,
          [flightType]: selectedFlight,
        },
      };
    case CLEAR_SELECTED_FLIGHT:
      return {
        ...state,
        selectedFlights: {
          ...state.selectedFlights,
          [flightType]: {},
        },
      };

    case STORE_RESERVATION_DETAILS:
      return {
        ...state,
        reservationDetails,
      };
    case SHOW_RESERVATION_FAILED_MESSAGE:
      return {
        ...state,
        reservationDetails: {
          reservation_status: 'failed',
        },
      };
    case UPDATE_TIMER:
      return {
        ...state,
        countdowntimer: {
          remainingTime,
        },
      };
    case INIT_PASSENGER_DETAILS:
      return {
        ...state,
        passengerDetails,
      };
    case UPDATE_PASSENGER_DETAIL:
      return {
        ...state,
        passengerDetails: {
          allIds: state.passengerDetails.allIds,
          byId: {
            ...state.passengerDetails.byId,
            [passengerId]: passengerDetail,
          },
        },
      };
    case STORE_CONTACT_DETAILS:
      return {
        ...state,
        contactPerson,
      };
    case STORE_FLIGHTS_PAYMENT_DETATILS:
      return {
        ...state,
        paymentDetails,
      };
    case BOOK_SELECTED_FLIGHTS:
      return {
        ...state,
        paymentDetails: {},
        reservationDetails: { reservation_status: '' },
      };
    case RESET_FLIGHTS_UI:
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/FlightsUiReducer.js